import React from "react";

const IgPosts = () => {
  return <div>IgPosts</div>;
};

export default IgPosts;
